<template>
  <div id="app">
    <router-view />
    <lang-switch />
  </div>
</template>
<script>
import lang_switch from "./components/lang_switch";
export default {
  data() {
    return {
      active: 0,
    }
  },
  components: {
    // 注意：注册名要和模板里的 <lang-switch /> 对得上，
    // Vue 只会尝试 lang-switch / langSwitch / LangSwitch，命名成 lang_switch 会解析不到
    "lang-switch": lang_switch,
  },
  methods: {

  }
}
</script>
<style >
#app {
  width: 100%;
}
.footer {
  width: 100%;

  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
}

</style>
